export default __webpack_public_path__ + "static/media/AureaMascote1.eaf88d54.png";